import '../stylesheets/application_mypage_blog';

import 'flatpickr/dist/flatpickr.min.css';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';

import 'flatpickr';
import 'flatpickr/dist/l10n/ja';
import 'slick-carousel';
import 'lightbox2';
